export const AUTH_REQUEST = "AUTH_REQUEST";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAILURE = "AUTH_FAILURE";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_SET_DATA = "AUTH_SET_DATA";
export const AUTH_LOGOUT_REQUEST = "AUTH_LOGOUT_REQUEST";

export const SET_DIRECCIONES = "SET_DIRECCIONES";
export const SET_ADICIONALES = "SET_ADICIONALES";
